<div class="container">
  <div class="page-header">
    <p class="eyebrow">{{ "novita.eyebrow" | translate }}</p>
    <h1 class="page-title">{{ "novita.title" | translate }}</h1>
    <p class="page-subtitle">{{ "novita.subtitle" | translate }}</p>
  </div>

  <div class="changelog-list">
    <div
      *ngFor="let entry of changelog; let first = first"
      class="changelog-entry"
    >
      <!-- Version header -->
      <div class="entry-header">
        <div class="entry-version-wrap">
          <span class="entry-version">v{{ entry.version }}</span>
          <span class="current-badge" *ngIf="entry.version === currentVersion">
            {{ "novita.current_version" | translate }}
          </span>
        </div>
        <span class="entry-date">{{ entry.date }}</span>
      </div>

      <!-- Sections -->
      <div class="entry-body">
        <div *ngFor="let section of entry.sections" class="entry-section">
          <span class="changelog-tag" [class]="section.tag">
            {{ section.label }}
          </span>
          <ul class="entry-list">
            <li *ngFor="let item of section.items">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
